import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-38520cfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "donate-description" }


export default /*#__PURE__*/_defineComponent({
  __name: 'BoostAlert',
  props: {
    text: {}
  },
  setup(__props: any) {


const props = __props


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_alert, {
      class: "alert mb-3",
      border: "start",
      color: "primary",
      title: _ctx.$t('BoostAlert.boost'),
      variant: "tonal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(props.text), 1),
        _createVNode(_component_v_btn, {
          class: "donate-button",
          color: "primary",
          size: "small",
          variant: "outlined",
          "prepend-icon": "favorite",
          to: "/donate"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('BoostAlert.donate')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title"])
  ]))
}
}

})